import script from "./CameraItemDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./CameraItemDetail.vue?vue&type=script&lang=ts&setup=true"

import "./CameraItemDetail.vue?vue&type=style&index=0&id=184f1bf8&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184f1bf8"]])

export default __exports__